import pluralize from 'pluralize'

angular
  .module 'filters'
  .filter 'singularize', ->
    (data) ->
      pluralize.singular(data)
